/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component (single bookable product row display)
 *   extends:   Component (@glimmer/component)
 *   template:  product-item.hbs
 *   args:      - (no this.args.* read in JS; see product-item.hbs for template-level args)
 *   uses:      session service
 *   siblings:  product-list.hbs (parent list template)
 *   tests:     ui-components-test.js, list-components-test.js
 */
import Component from '@glimmer/component';
import { service } from '@ember/service';

export default class ProductItemComponent extends Component {
  @service session;
}
